import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import PropertyDetailsPage from './pages/PropertyDetailsPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/" element={<App data-id="element-4" />} data-id="element-3" />
        <Route path="/settings" element={<SettingsPage data-id="element-6" />} data-id="element-5" />
        <Route path="/property-details" element={<PropertyDetailsPage data-id="element-8" />} data-id="element-7" />
        <Route path="/reports" element={<ReportsPage data-id="element-10" />} data-id="element-9" />
      </Routes>
    </BrowserRouter>;
}